<template>
  <div class="mian-layout" id="app">
    <el-container>
      <sidebar></sidebar>
      <el-main class="main-panel">
        <!-- <keep-alive> -->
        <router-view></router-view>
        <!-- </keep-alive> -->
      </el-main>
    </el-container>
  </div>
</template>
<script>
  import sidebar from "./sidebar";
  export default {
    name: "SysManager",
    data() {
      return {};
    },
    components: {
      sidebar
    },
    methods: {
      OpenComponent(key) {
        // console.log(key);
      }
    }
  };
</script>
<style lang="scss" scoped>
  #app {
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/SysManager/index.vue